import React from 'react';
import Joi from 'joi-browser';
import Form from '../../../common/form';

class ProfileForm extends Form {
	state = {
		data: {
			bemchainCenter: this.props.uid,
			email: this.props.email,
			sponsor: this.props.sponsor || 'Is Not Defined',
			fullName: this.props.fullName || '',
			country: this.props.country || '',
			nationalID: this.props.nationalID || '',
			phoneNumber: this.props.phoneNumber || '',
			securityPassword: this.props.securityPassword || '',
		},
		errors: {},
		dial_code: '+',
	};

	schema = {
		bemchainCenter: Joi.string().required().label('Bemchain Center'),
		email: Joi.string().email().required().label('Email'),
		sponsor: Joi.string().required().label('Sponsor ID'),
		fullName: Joi.string().required().label('Full Name'),
		country: Joi.string().required().label('Country'),
		nationalID: Joi.string().required().label('National ID / Passport No.'),
		phoneNumber: Joi.number().required().label('Phone Number'),
		securityPassword: Joi.string().required().label('Security Password'),
	};

	countryChanged = ({ currentTarget: text }) => {
		const { countries } = this.props;
		const country = countries.find((c) => c.name === text.value);
		this.setState({ dial_code: country.dial_code });
	};

	doSubmit = () =>
		this.props.onSubmit({
			...this.state.data,
			...{ dial_code: this.state.dial_code },
		});

	componentDidMount() {
		if (this.props.country) {
			const { countries } = this.props;
			const country = countries.find(
				(c) => c.name === this.props.country
			);
			this.setState({ dial_code: country.dial_code });
		}
	}

	componentWillUnmount() {
		// fix Warning: Can't perform a React state update on an unmounted component
		this.setState = (state, callback) => {
			return;
		};
	}

	render() {
		const { isLoading, countries, hasSP } = this.props;
		const { dial_code } = this.state;
		return (
			<form
				className='text-start'
				autoComplete='off'
				onSubmit={this.handleSubmit}>
				<div className='mb-3'>
					{this.renderInput({
						name: 'bemchainCenter',
						label: 'Bemchain Center (bc)',
						type: 'text',
						disabled: true,
					})}
				</div>
				<div className='mb-3'>
					{this.renderInput({
						name: 'email',
						label: 'Email',
						type: 'email',
						disabled: true,
					})}
				</div>
				<div className='mb-3'>
					{this.renderInput({
						name: 'sponsor',
						label: 'Sponsor ID',
						type: 'text',
						disabled: true,
					})}
				</div>
				<div className='mb-3'>
					{this.renderInput({
						name: 'fullName',
						label: 'Full Name',
						type: 'text',
					})}
				</div>
				<div className='mb-3'>
					{this.renderSelectNormal({
						name: 'country',
						label: 'Country',
						options: countries.map((c) => c.name),
						extraHandler: this.countryChanged,
					})}
				</div>
				<div className='mb-3'>
					{this.renderInputGroup({
						name: 'phoneNumber',
						label: 'Phone Number',
						type: 'text',
						spanText: dial_code,
					})}
				</div>
				<div className='mb-3'>
					{this.renderInput({
						name: 'nationalID',
						label: 'National ID / Passport No.',
						type: 'text',
					})}
				</div>
				{this.renderSubmitBtnWithSPass({
					divClass: 'mb-3',
					hasSP,
					isLoading,
					text: 'Update',
					loadingText: 'Updating...',
				})}
			</form>
		);
	}
}

export default ProfileForm;
